import styled from 'styled-components';

export const Item = styled.div`
  display: flex;
  gap: 4px;
  padding: 12px 0px;
  flex-direction: column;
`;

export const Key = styled.div`
  color: var(--Gray-Scale-600, #756f7e);

  /* NEW/body_03_regular */
  font-family: 'Pretendard Variable';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;

export const Value = styled.div`
  color: var(--Gray-Scale-400, #bcb8c3);

  /* NEW/body_02_regular */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;

export const Unit = styled(Key)`
  font-weight: 500;
`;

export const Label = styled(Key).attrs({ as: 'label' })``;
